import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr auto;
  place-items: center start;
  margin: 0 auto;
  max-width: 1000px;
  @media (max-width: 825px) {
    grid-template-columns: 1fr;
  }
`;

export const Link = styled.button`
  color: var(--color);
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  align-items: center;
  cursor: ${({ cursor }) => cursor};
  &:disabled {
    opacity: 0.6;
  }
`;
